var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedkitFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 6c-.82843 0-1.5.67157-1.5 1.5v12c0 .8284.67157 1.5 1.5 1.5h16.5c.8284 0 1.5-.6716 1.5-1.5v-12c0-.82843-.6716-1.5-1.5-1.5H3.75Zm9 3.75c0-.41421-.3358-.75-.75-.75s-.75.33579-.75.75v3h-3c-.41421 0-.75.3358-.75.75s.33579.75.75.75h3v3c0 .4142.3358.75.75.75s.75-.3358.75-.75v-3h3c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75h-3v-3Z",
    fill: "#667E87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3c-.19891 0-.38968.07902-.53033.21967C7.57902 3.36032 7.5 3.55109 7.5 3.75v.75h9v-.75c0-.19891-.079-.38968-.2197-.53033C16.1397 3.07902 15.9489 3 15.75 3h-7.5Z",
    fill: "#667E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedkitFilled);
export default __webpack_public_path__ + "static/media/medkit_filled.bd0e6f853a461cdc8bfa7325a8050e36.svg";
export { ForwardRef as ReactComponent };